import { dataPasteSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPasteSolid = /*#__PURE__*/createIcon(dataPasteSolid)
export default IconPasteSolid
